// extracted by mini-css-extract-plugin
export var borderRadius = "_e8-4";
export var large = "_e8-3";
export var logoContainer = "_e8-0";
export var nameLogo = "_e8-2";
export var small = "_e8-1";